import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateOrderStatus } from "../../api/orders.api";
import { toast } from "react-toastify";
import { productKeys } from "../../queryKeys";

export const useUpdateOrderStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ orderId, status }: { orderId: string; status: string }) =>
      updateOrderStatus(orderId, status),

    onSuccess: (res, variables) => {
      if (res?.message?.toLowerCase() === "success") {
        toast.success("Order status updated!");

        // ✅ Refresh orders list
        queryClient.invalidateQueries({
          queryKey: productKeys.all,
        });

        // Optional: invalidate single order
        queryClient.invalidateQueries({
          queryKey: [...productKeys.all, variables.orderId],
        });
      }
    },

    onError: (error) => {
      console.error(error);
      toast.error("Failed to update order status");
    },
  });
};
